import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import './Login.css';
import logoLB from '../../assets/img/logoLB.png';

function Login({ onLogin }) {
  const [formData, setFormData] = useState({
    usuario: '',
    clave: ''
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionStatus = searchParams.get('session');
    if (sessionStatus === 'expired') {
      setError('Su sesión ha expirado por inactividad. Por favor, inicie sesión nuevamente.');
    } else if (sessionStatus === 'closed') {
      setError('Su sesión ha sido cerrada. Por favor, inicie sesión nuevamente.');
    }

    return () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    };
  }, [searchParams]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (!error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    if (!error) setError('');

    try {
      const res = await fetch('https://apiprov.conduto.com.ec/api/login', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          usuario: formData.usuario,
          clave: formData.clave
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        const errorMessage = data.detail || data.msg || 'Usuario o clave incorrectos';
        throw new Error(errorMessage);
      }

      localStorage.setItem('tokenTimestamp', Date.now().toString());

      await onLogin(data.usuario);

      const redirectFromState = location.state?.from?.pathname + (location.state?.from?.search || '');

      const redirectTo = (redirectFromState && redirectFromState !== '/login') ? redirectFromState : (
        localStorage.getItem('redirectAfterLogin') ||
        data.ultima_ruta ||
        (data.usuario?.rol === 'proveedor' ? '/form' : '/administrador')
      );

      localStorage.removeItem('redirectAfterLogin');

      navigate(redirectTo, { replace: true });

    } catch (err) {
      setError(err.message || 'Error al conectar con el servidor');
      localStorage.removeItem('tokenTimestamp');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="background-image"></div>
      <div className="login-page d-flex justify-content-center align-items-center vh-100">
        <div className="login-card d-flex rounded shadow overflow-hidden">
          <div className="login-left position-relative">
            <div className="overlay"></div>
            <div className="welcome-text text-white position-relative z-1">
              <h3 style={{ fontFamily: 'Georgia, serif' }}>Sistema de Calificación de proveedores</h3>
              <h1 style={{ fontFamily: 'Georgia, serif' }}>BIENVENIDO</h1>
            </div>
          </div>
          <div className="login-right p-4 bg-white d-flex flex-column justify-content-center">
            <div className="text-center mb-4">
              <img src={logoLB} alt="Logo" className="img-fluid" style={{ maxWidth: '350px' }} />
            </div>
            <h3 className="mb-4 text-center" style={{ color: '#055697', fontSize: '2rem', fontFamily: 'Georgia, serif' }}>
              Iniciar Sesión
            </h3>
            {error && (
              <div className="text-left error-message" role="alert" aria-live="assertive" style={{ color: 'red' }}>
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  name="usuario"
                  className="form-control"
                  placeholder="Usuario"
                  value={formData.usuario}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  autoComplete="username"
                />
              </div>
              <div className="mb-3 position-relative">
                <input
                  type="password"
                  name="clave"
                  className="form-control pr-5"
                  placeholder="Contraseña"
                  value={formData.clave}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  autoComplete="current-password"
                />
              </div>
              <button
                type="submit"
                className="btn w-100"
                style={{ backgroundColor: '#055697', color: '#fff' }}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Iniciando sesión...
                  </>
                ) : (
                  'INICIAR SESIÓN'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
